import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function CafeChokChokVideo() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section data-testid="cafe-chok-chok-video-section" ref={ref} className="relative w-full">
      {/* Video container - brighter, focal point shifted down to products */}
      <div className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          data-testid="cafe-chok-chok-video"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 70%' }}
        >
          <source src="/videos/cafe-chok-chok.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-[#0A0A0A]/10" />

        {/* Location caption */}
        <div className="absolute bottom-6 right-8 md:bottom-8 md:right-12">
          <p className="font-serif italic text-white/30 text-xs md:text-sm tracking-wide">
            Nykaaland, Delhi
          </p>
        </div>
      </div>

      {/* Caption */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="bg-[#EFEAE6] py-10 md:py-14 px-6 text-center"
      >
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#8C8C8C] font-light">
          A glimpse into what we create.
        </p>
      </motion.div>
    </section>
  );
}
